<script lang="ts">
    import cn from "classnames";
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    export let currentSort: string;
    export let tabs: { value: string; name: string }[];

    const dispatch = createEventDispatcher();

    const onClick = (value: string) => {
        dispatch("sort", value);
    };
</script>

<div class="gw-sort">
    {#each tabs as tab}
        <BaseButton
            class={cn("gw-sort__btn", {
                "gw-sort__btn-opened": currentSort === tab.value,
            })}
            on:click={() => onClick(tab.value)}>{tab.name}</BaseButton
        >
    {/each}
</div>

<style lang="postcss">
    .gw-sort {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 22px;
        margin-bottom: 24px;
    }

    :global(.gw-btn.gw-sort__btn) {
        font-family: "Noto Sans TC";
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #3c3c3c;
    }

    :global(.gw-btn.gw-sort__btn.gw-btn.gw-sort__btn-opened) {
        color: red;
    }

    @media (max-width: 600px) {
        .gw-sort {
            margin-bottom: 20px;
        }

        :global(.gw-btn.gw-sort__btn) {
            font-size: 12px;
            line-height: 17px;
        }
    }
</style>
